<template>
	<div id="app">
		<div class="Table" style="height: 40px;">
			<nav-bar text="课程详情" @blackclick="backclick" :isblack="true" :textcolor="1"
				image="../../src/assets/hback.png"></nav-bar>
		</div>
		<div class="Table">
			<div class="tabletimes">
				<span>上课时间：</span>
				<div>{{classdata.courseDate}}</div>
			</div>
			<div class="tableschool">
				<span>任课老师：</span>
				<span>{{classdata.mainTeacherName}}</span>
			</div>
			<div class="tableschool">
				<span>助教：</span>
				<span>{{classdata.assistTeacher}}</span>
			</div>
			<div class="tableschool" style="color: #ff0000;" v-if="classdata.attendLocked==1">
				本次签到数据已锁定，如需修改请联系校务人员
			</div>
		</div>
		<div class="Table">
			<div style="display: flex;padding-top: 10px;">
				<div class="" style="width: 30%;text-align: center;">学员</div>
				<div class="" style="width: 30%;text-align: center;">学管师</div>
				<div class="" style="width: 20%;text-align: center;">出勤</div>
				<div class="" style="width: 20%;text-align: center;margin-right: 10px;">缺勤原因</div>
			</div>
			<div style="display: flex;justify-content: center;align-items: center;margin-top: 10px;"
				v-for="(item,index) in classdata.students" :key="index">
				<div class="tablemanagerTeacher">
					{{item.customerName}}
				</div>
				<div class="tablemanagerTeacher">
					{{item.managerTeacher}}
				</div>
				<input class="tableitem" type="checkbox" :checked="item.attendStatus==1"
					:disabled="item.absenceReason!=''|| classdata.attendLocked==1" @change="checkboxChange(index)"
					style=”width:20px;height:20px;”>
				<div class="tablepick" @click="itemindex(index)">
					<select class="select" v-on:change="indexSelect($event)" v-model="item.absenceReason">
						<option v-for="(items, indexs) in array" :key="indexs" :value="items"
							:disabled='item.attendStatus==1 || classdata.attendLocked==1'>{{items}}</option>
					</select>
				</div>
			</div>
			<div v-if="classdata.attendLocked==0" style="padding: 30px 10px 10px;display: flex;justify-content: right;">
				<div class="allcheckbuton" @click="allcheck">
					全选
				</div>
			</div>
		</div>
		<div class="footer">
			<div class="fottext">
				应到：{{studentlength}}
			</div>
			<div class="fottext">
				出勤：{{attendnum}}
			</div>
			<div class="fotbuton" @click="submitAttendance">
				签到
			</div>
		</div>
	</div>
</template>

<script>
	import {
		basCourseDetail,
		basCourseAttend
	} from '../request/api.js';
	import NavBar from "../../src/components/navBar.vue";
	export default {
		components: {
			NavBar,
		},
		data() {
			return {
				noClick: true,
				array: ['', '事假', '病假', '停科', '换班', '非常规学员', '其它或未知原因'],
				index: '',
				courseid: 0,
				classdata: {},
				attendnum: 0,
				studentlength: 0,
			}
		},
		created() {
			this.courseid = this.$route.params.id;
			if (this.courseid) {
				this.getbasCourseDetail();
			} else {
				this.$router.push({
					path: '/myschedule',
					query: {
						courseDay: this.classdata.courseDay
					},
				});
			}
		},
		methods: {
			backclick() {
				this.$router.back() //路由跳转
			},
			getbasCourseDetail() {
				var that = this;
				basCourseDetail('courseId=' + that.courseid).then((res) => {
					if (res.data.code == 0) {
						that.classdata = res.data.data;
						that.studentlength = that.classdata.students.length;
						that.attendnum = 0;
						that.classdata.students.forEach(function(res, index) {
							if (res.attendStatus == 1) {
								that.attendnum += 1
							}
						})
					} else {
						that.$message({
							message: res.data.msg,
							type: 'warning',
						})
					}
				});
			},
			itemindex(num) {
				this.index = num;
				if (this.classdata.students[this.index].attendStatus == 1 && this.classdata.attendLocked == 0) {
					this.$message({
						message: '已出勤禁止选缺勤原因',
						type: 'warning',
					})
				}
			},
			indexSelect(e) {
				var that = this;
				var indexb = e.target.selectedIndex;
				that.classdata.students[that.index].absenceReason = that.array[indexb];
				if (!that.array[indexb]) {
					that.classdata.students[that.index].absenceReason = '';
				}
				that.attendnum = 0;
				that.classdata.students.forEach(function(res, index) {
					if (res.attendStatus == 1) {
						that.attendnum += 1
					}
				})
			},
			checkboxChange(index) {
				var that = this;
				if (that.classdata.students[index].absenceReason) {
					that.$message({
						message: '已选缺勤原因禁止勾选出勤',
						type: 'warning',
					})
					return
				}
				if (that.classdata.students[index].attendStatus == 0) {
					that.classdata.students[index].attendStatus = 1;
				} else {
					that.classdata.students[index].attendStatus = 0;
				}
				that.attendnum = 0;
				that.classdata.students.forEach(function(res, index) {
					if (res.attendStatus == 1) {
						that.attendnum += 1
					}
				})
			},
			allcheck() {
				var that = this;
				that.attendnum = 0;
				that.classdata.students.forEach(function(res, index) {
					if (res.absenceReason == '') {
						res.attendStatus = 1
						that.attendnum += 1
					}
				})
			},
			// 检查学生签到状态
			checkStudentsAttendance(students) {
				return students.some(student => {
					if (student.attendStatus == 0 && student.absenceReason == '') {
						return true; // 发现未签到且未填写原因的学生
					}
				});
			},
			// 提交数据
			submitAttendance() {
				var that = this;
				if (that.classdata.attendLocked == 0) {
					// 判断日期是否在当前月份，并且是否在包括今天在内的七天之内（不包括今天之后的日期）
					if (!that.$utils.isDateInCurrentMonthAndWithinSevenDays(that.classdata.courseDay)) {
						that.$message({
							message: '签到失败，只能签到本月7天之内的课程',
							type: 'warning',
						});
						return; // 终止后续操作
					}

					// 检查学生签到状态
					if (that.checkStudentsAttendance(that.classdata.students)) {
						that.$message({
							message: '有学生未签到请填写原因',
							type: 'warning',
						});
						return; // 终止后续操作
					}

					// 调用接口提交数据
					basCourseAttend(that.classdata).then((res) => {
						if (res.data.code == 0) {
							that.$message({
								message: '提交成功',
								type: 'success',
							});
							this.$router.push({
								path: '/myschedule',
								query: {
									courseDay: that.classdata.courseDay
								},
							});
						} else {
							that.$message({
								message: res.data.msg,
								type: 'warning',
							});
						}
					}).catch(error => {
						console.error('提交失败:', error);
						that.$message({
							message: '提交失败，请重试',
							type: 'error',
						});
					});
				} else {
					that.$message({
						message: '本次签到数据已锁定，如需修改请联系校务人员',
						type: 'warning',
					})
				}
			}
		}
	}
</script>

<style>
	.select {
		border: none;
		box-shadow: none;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		height: 30px;
	}

	.Table {
		width: 96%;
		margin: 10px auto;
		border-radius: 6px;
		/* box-shadow: 0px 10px 14px 10px rgb(139 139 139 / 20%); */
	}

	.tabletimes {
		display: flex;
		padding: 10px;
	}

	.tableschool {
		padding: 10px;
	}

	.tableitem {
		width: 20%;
		text-align: center;
		height: 36px;
		line-height: 36px;
	}

	.tablemanagerTeacher {
		width: 30%;
		text-align: center;
		height: 36px;
		line-height: 36px;
	}

	.tablepick {
		width: 23%;
		text-align: center;
		height: 36px;
		line-height: 36px;
		border-bottom: 1px solid;
		margin-right: 10px;
	}

	.allcheckbuton {
		width: 25%;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 34px;
		border-radius: 5px;
		border: 2px solid #169bd5;
		color: #169bd5;
	}

	.footer {
		position: fixed;
		width: 100%;
		bottom: 0;
		display: flex;
		height: 70px;
		justify-content: center;
		align-items: center;
		background-color: #fff;
	}

	.fottext {
		width: 30%;
		display: flex;
		align-items: center;
	}

	.fotbuton {
		width: 30%;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 40px;
		color: #fff;
		background-color: #169bd5;
		border-radius: 5px;
	}
</style>